import { Mtds, PlusIcon, SinglePlan } from 'prove-common'

type EmptyStateProps = {
  onOpenCreateTaskModal: () => void
  onOpenCreatePlanModal: () => void
  plan?: SinglePlan
}

export const EmptyState = ({
  onOpenCreateTaskModal,
  onOpenCreatePlanModal,
  plan
}: EmptyStateProps) => {
  const needToEditPlan = plan?.contractId == null && plan?.tasks?.length === 0
  const tooltip = needToEditPlan
    ? 'Husk å knytte planen til en kontrakt for å kunne legge til oppgaver. Dette kan gjøres ved å redigere planen'
    : undefined
  return (
    <Mtds.Card
      as={Mtds.Grid}
      data-align='center'
      data-justify='center'
      data-pad='18'
    >
      <svg
        className='w-[450px] -mt-20'
        width='468'
        height='450'
        viewBox='0 0 468 450'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <circle
          cx='243'
          cy='225'
          r='53.7266'
          stroke='var(--mtds-color-border-subtle)'
        />
        <circle
          opacity='0.6'
          cx='243'
          cy='225'
          r='90.1475'
          stroke='var(--mtds-color-border-subtle)'
        />
        <circle
          opacity='0.4'
          cx='243'
          cy='225'
          r='131.424'
          stroke='var(--mtds-color-border-subtle)'
        />
        <circle
          opacity='0.2'
          cx='243'
          cy='225'
          r='178.367'
          stroke='var(--mtds-color-border-subtle)'
        />
        <circle
          opacity='0.1'
          cx='243'
          cy='225'
          r='224.5'
          stroke='var(--mtds-color-border-subtle)'
        />
        <path
          d='M259.25 212.143C261.281 212.143 263 213.911 263 216V239.143C263 241.312 261.281 243 259.25 243H226.75C224.641 243 223 241.312 223 239.143V210.857C223 208.768 224.641 207 226.75 207H239.25L244.25 212.143H259.25ZM249.25 229.5C250.266 229.5 251.125 228.696 251.125 227.571C251.125 226.527 250.266 225.643 249.172 225.643H244.797V221.143C244.797 220.098 244.016 219.214 243 219.214C241.906 219.214 241.125 220.098 241.047 221.143V225.723H236.672C235.656 225.723 234.875 226.527 234.875 227.571C234.875 228.696 235.656 229.5 236.672 229.5H241.125V234.08C241.125 235.125 241.906 235.929 243 235.929C244.016 235.929 244.797 235.125 244.875 234V229.5H249.25Z'
          fill='currentColor'
        />
        <circle
          cx='378'
          cy='176'
          r='21'
          fill='var(--mtds-color-neutral-surface-tinted)'
        />
        <circle
          cx='132'
          cy='160'
          r='21'
          fill='var(--mtds-color-neutral-surface-tinted)'
        />
        <circle
          cx='21'
          cy='209'
          r='21'
          fill='var(--mtds-color-neutral-surface-tinted)'
        />
        <path
          opacity='0.7'
          d='M385.188 176.25C385.188 176.883 384.66 177.41 384.062 177.41H379V182.473C379 183.07 378.473 183.562 377.875 183.562C377.242 183.562 376.75 183.07 376.75 182.473V177.41H371.688C371.055 177.41 370.562 176.883 370.562 176.25C370.562 175.652 371.055 175.16 371.688 175.16H376.75V170.098C376.75 169.465 377.242 168.938 377.875 168.938C378.473 168.938 379 169.465 379 170.098V175.16H384.062C384.66 175.125 385.188 175.652 385.188 176.25Z'
          fill='currentColor'
        />
        <path
          opacity='0.56'
          d='M126 154.5C126 153.543 126.766 152.75 127.75 152.75H132.262C132.727 152.75 133.164 152.941 133.492 153.27L135.98 155.758C136.309 156.086 136.5 156.523 136.5 156.988V165C136.5 165.984 135.707 166.75 134.75 166.75H127.75C126.766 166.75 126 165.984 126 165V154.5ZM135.188 165V157.125H133C132.508 157.125 132.125 156.742 132.125 156.25V154.062H127.75C127.504 154.062 127.312 154.281 127.312 154.5V165C127.312 165.246 127.504 165.438 127.75 165.438H134.75C134.969 165.438 135.188 165.246 135.188 165Z'
          fill='currentColor'
        />
        <path
          opacity='0.4'
          d='M16.4062 203.062C16.7617 203.062 17.0625 203.363 17.0625 203.719V205.031C17.0625 205.414 16.7617 205.688 16.4062 205.688H15.0938C14.7109 205.688 14.4375 205.414 14.4375 205.031V203.719C14.4375 203.363 14.7109 203.062 15.0938 203.062H16.4062ZM27.125 203.5C27.5898 203.5 28 203.91 28 204.375C28 204.867 27.5898 205.25 27.125 205.25H19.25C18.7578 205.25 18.375 204.867 18.375 204.375C18.375 203.91 18.7578 203.5 19.25 203.5H27.125ZM27.125 207.875C27.5898 207.875 28 208.285 28 208.75C28 209.242 27.5898 209.625 27.125 209.625H19.25C18.7578 209.625 18.375 209.242 18.375 208.75C18.375 208.285 18.7578 207.875 19.25 207.875H27.125ZM27.125 212.25C27.5898 212.25 28 212.66 28 213.125C28 213.617 27.5898 214 27.125 214H19.25C18.7578 214 18.375 213.617 18.375 213.125C18.375 212.66 18.7578 212.25 19.25 212.25H27.125ZM14.4375 208.094C14.4375 207.738 14.7109 207.438 15.0938 207.438H16.4062C16.7617 207.438 17.0625 207.738 17.0625 208.094V209.406C17.0625 209.789 16.7617 210.062 16.4062 210.062H15.0938C14.7109 210.062 14.4375 209.789 14.4375 209.406V208.094ZM16.4062 211.812C16.7617 211.812 17.0625 212.113 17.0625 212.469V213.781C17.0625 214.164 16.7617 214.438 16.4062 214.438H15.0938C14.7109 214.438 14.4375 214.164 14.4375 213.781V212.469C14.4375 212.113 14.7109 211.812 15.0938 211.812H16.4062Z'
          fill='currentColor'
        />
      </svg>
      <Mtds.Prose
        as={Mtds.Grid}
        data-justify={'center'}
        className='w-96 -mt-32 text-center'
      >
        <Mtds.Heading>Kom i gang med planleggingen</Mtds.Heading>
        <p>
          Det ser ut som det er tomt her. Hvorfor ikke starte med å opprette en
          ny plan eller oppgave?
          {needToEditPlan && (
            <Mtds.Alert data-color='info'>
              Husk å knytte planen til en kontrakt for å kunne legge til
              oppgaver. Dette kan gjøres ved å redigere planen.
            </Mtds.Alert>
          )}
        </p>
        <Mtds.Flex data-justify='center'>
          <Mtds.Button
            disabled={needToEditPlan}
            onClick={onOpenCreateTaskModal}
            data-tooltip={tooltip}
            data-variant='secondary'
          >
            Opprett oppgave
          </Mtds.Button>
          <Mtds.Button onClick={onOpenCreatePlanModal} data-variant='primary'>
            <PlusIcon />
            Opprett plan
          </Mtds.Button>
        </Mtds.Flex>
      </Mtds.Prose>
    </Mtds.Card>
  )
}
